import * as React from 'react';

import withApollo from 'lib/apollo';

import { Layout } from 'components/Layout/Layout';
import CMSPage from 'components/PageWrapper/PageWrapper';

import { PublicCMSLayout } from '../components/Layout/PublicCMSLayout';

function PrivacyPage() {
  return (
    <Layout classNames={['h-background--navy-200']} title="Privacy Policy">
      <PublicCMSLayout additionalClassNames="c-privacy-page">
        <CMSPage pageUrl="privacy" title="Privacy Policy" />
      </PublicCMSLayout>
    </Layout>
  );
}

export default withApollo(PrivacyPage, { useTemporaryToken: true });
